import { combineReducers } from 'redux';

import {
  GET_PLANS_START,
  GET_PLANS_SUCCESS,
  GET_PLANS_FAIL,
  // from gwt:
  GET_PLAN_PROPERTIES_START,
  // GET_PLAN_PROPERTIES_SUCCESS,
  // GET_PLAN_PROPERTIES_FAIL,
} from 'actions/eventFloodControl';

export const defaultPlansState = {
  loading: false,
  error: false,
  data: [],
};

export function plans(state = defaultPlansState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_PLANS_START:
      return {
        ...state,
        loading: true,
      };
    case GET_PLANS_SUCCESS:
      return {
        ...state,
        data: payload.data,
        loading: false,
        error: false,
      };
    case GET_PLANS_FAIL:
      return {
        ...state,
        loading: false,
        error: true,
      };
    default:
      return state;
  }
}

export const defaultPropertiesState = {
  loading: false,
  error: false,
  data: null,
  selected: [],
};

export const properties = (state = defaultPropertiesState, action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_PLAN_PROPERTIES_START:
      return {
        ...state,
        data: null,
      };
    case 'GET_PLAN_PROPERTIES_SUCCESS':
      return {
        ...state,
        // reconstructing the array in this way (instead of .concat)
        // makes sure Array.prototype.find and friends get polyfilled
        data: [
          ...payload,
          { name: 'RECIPIENTS', baseType: 'ATTRIBUTE' },
          { name: 'PRIORITY', baseType: 'ATTRIBUTE' },
          { name: 'INITIATOR', baseType: 'ATTRIBUTE' },
          { name: 'INCIDENT', baseType: 'ATTRIBUTE' },
          { name: 'INTEGRATION', baseType: 'ATTRIBUTE' },
        ],
      };
    default:
      return state;
  }
};

export default combineReducers({ plans, properties });
